<template>
    <div id='Settings'>
        <div class="head">
            <div class="pubw">
                <h2 class="h">個人設置</h2>
            </div>
        </div>
        <div class="body">
            <div class="pubw">
                <NavMenu/>
                <div class="edit">
                    <div class="item">
                        <div class="label">用戶名</div>
                        <el-input
                            placeholder="修改用户名"
                            prefix-icon="el-icon-user"
                            v-model="form.name"
                            @focus="handlerNameIptFocus"
                            @blur="handlerNameIptBlur"
                            >
                        </el-input>
                        <optionsButton title="修改" :callback="editName" ref="editNameBtn"/>
                    </div>
                    <div class="item">
                        <div class="label">邮箱</div>
                        <el-input
                            placeholder="邮箱"
                            prefix-icon="el-icon-message"
                            v-model="form.email"
                            disabled>
                        </el-input>
                    </div>
                    <div class="item chagnePsw">
                        <div class="label" @click="showDiaLog = true">修改密码</div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 编辑对话框 -->
        <el-dialog
            :title="dialogTitle"
            :visible.sync="showDiaLog"
            :before-close="handleClose"
            width="1280px"
            :close-on-click-modal="false"
            >
            <el-form :model="pwdForm" :rules="pwdFormRules" ref="pwdFormRulesForm">
                <el-form-item label="舊密碼" prop="oldPassword">
                  <el-input v-model="pwdForm.oldPassword" type="password"></el-input>
                </el-form-item>
                <el-form-item label="新密碼" prop="password">
                    <el-input v-model="pwdForm.password" type="password"></el-input>
                  </el-form-item>
                  <el-form-item label="確認密碼" prop="pwdConfirm">
                    <el-input v-model="pwdForm.pwdConfirm" type="password"></el-input>
                  </el-form-item>
            </el-form>
            <span class="mydialog-footer">
                <p @click="handleClose">取 消</p>
                <optionsButton title="确定" :callback="editPwd"/>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import optionsButton from '@/components/optionButton'
import NavMenu from "@/components/NavMenu.vue"
export default {
    name:'Settings',
    components:{
        NavMenu,
        optionsButton
    },
    data(){

              // 验证密码
            let validatePass2 = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error("请重新输入确认密码"));
                } else if (value !== this.pwdForm.password) {
                    callback(new Error("两次密码不一致"));
                } else {
                     callback();
                }
            }
        return {
            // 对话框是否展示
            showDiaLog: false,
            // 对话框的标题
            dialogTitle: '',
            // 用户信息
            userInfo: {},
            // 编辑表单
            form:{
                name: '',
                email: '',
            },
            // 密码表单
            pwdForm: {
                oldPassword: '',
                password: '',
                pwdConfirm: ''
            },
            // 密码表单规则
            pwdFormRules: {
                oldPassword: [
                    { required: true, message: "请填写密码", trigger: 'blur' },
                    { min: 6, max: 20, message: "密码长度在6到20之间", trigger: 'blur' }
                ],
                password:[
                    { required: true, message: "请填写密码", trigger: 'blur' },
                    { min: 6, max: 20, message: "密码长度在6到20之间", trigger: 'blur' }
                ],
                pwdConfirm:[
                    { required: true, validator: validatePass2, trigger: 'blur' },
                    { min: 6, max: 20, message: "两次输入密码不一致", trigger: 'blur' }
                ],

            }
        }
    },
    methods: {
        // 监听对话框关闭
        handleClose(){
            this.showDiaLog = false
        },
        // 获取用户信息
        async getUserInfo(){
            const res = await this.$http.get("app/user/getusercp")
            console.log(res,"用户信息")
            this.userInfo = res.data.data
            this.form.name  = this.userInfo.nickname
            this.form.email  = this.userInfo.email
        },
        // 修改密码
        editPwd(){
            this.$refs.pwdFormRulesForm.validate(async valid => {
                if(!valid) return 

                const res = await this.$http.put("/app/user/setPassword",null,
                {
                    params:{
                        password: this.pwdForm.password,
                        oldPassword: this.pwdForm.oldPassword
                    }
                })
                console.log(res,"修改密码结果")
                if(res.data.code <= 0){
                    return this.$message.error(res.data.message)
                }
                if(res.data.code == 1){
                    return this.$message.success("修改成功")
                    this.handleClose()
                } 
            })
        },
        // 监听用户名获得焦点
        handlerNameIptFocus(){
           this.$refs.editNameBtn.$el.style.width = '150px'
        },
        // 监听用户名失去焦点
        handlerNameIptBlur(){
            this.$refs.editNameBtn.$el.style.width = '0px'
        },
        // 修改用户名
        async editName(){
            if(this.form.name != ''){
                const res = await this.$http.put("/app/user/setName?name=" + this.form.name)
                console.log(res,"修改名称结果")
                if(res.data.code == 1){
                    this.$message.success("修改成功")
                }
                this.getUserInfo()
            }else{
                this.form.name = this.userInfo.nickName 
            }
        }
    },
    // 生命周期==>创建完成
    created() {
        this.getUserInfo()
    },
    mounted() {
    },
}
</script>

<style lang="less">
    #Settings{
        background-color: #F2F2F2;
        .head{
            background-color: #F2F2F2;
            height: 258px;
            padding-top:130px;
            .h{
                font-weight: 600;
                font-size: 30px;
            }
        }
        .body{
            display: flex;
            justify-content: space-between;
            &>.pubw{
                display: flex;
                justify-content:space-between;
            }
            .edit{
                width: 100%;
                .item{
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 30px;
                    height: 50px;
                    .label{
                        font-size: 20px;
                        white-space: nowrap;
                        width: 10%;
                    }
                    .v{
                        font-weight: 580;
                        font-size: 23px;
                    }
                    .el-input{
                        width: 90%;
                        height: 100%;
                        .el-input__inner{
                            padding-left: 35px;
                            font-size: 20px;
                        }
                        .el-input__prefix{
                            font-size: 20px;
                            top: 4px;
                        }
                    }
                    button{
                        width: 0px;
                        overflow: hidden;
                        padding: 0;
                        margin-left: 5px;
                        transition: all .6s;
                    }
                    .active{
                            width: 200px !important;
                    }
                }
                .chagnePsw{
                    justify-content: flex-end;
                    .label{
                        color: @colorMain;
                        &:hover{
                            opacity: .8;
                            cursor: pointer;
                        }
                    }
                }
            }

        }
    }
</style>